import ComingSoon from "../components/comingSoon";
import { FaRegCircle, FaUser } from "react-icons/fa";
import ProviderList from "../views/UserManagement/ProviderList";
import CustomerList from "../views/UserManagement/CustomerList";
import ProviderDetails from "../views/UserManagement/ProviderDetails";
import CustomerDetails from "../views/UserManagement/CustomerDetails";
import AddCustomer from "../views/UserManagement/AddCustomer";
import EditCustomer from "../views/UserManagement/EditCustomer";
import ProviderServiceDetails from "views/UserManagement/ProviderServiceDetails";
import UpdateProviderServiceDetails from "views/UserManagement/UpdateProviderServiceDetails";
import AddProvider from "views/UserManagement/AddProvider";

const UserRoutes = [
  {
    path: "/customer/add",
    name: "Add Customer",
    icon: "nc-icon nc-bank",
    component: <AddCustomer />,
    layout: "/admin",
    showInSidebar: false
  },
  {
    path: "/customer/edit",
    name: "Edit Customer",
    icon: "nc-icon nc-bank",
    component: <EditCustomer />,
    layout: "/admin",
    showInSidebar: false
  },
  {
    path: "/customer/edit",
    name: "Edit Customer",
    icon: "nc-icon nc-bank",
    component: <ComingSoon />,
    layout: "/admin",
    showInSidebar: false
  },
  {
    path: "/provider/add",
    name: "Add Provider",
    icon: "nc-icon nc-bank",
    component: <AddProvider />,
    layout: "/admin",
    showInSidebar: false
  },
  {
    path: "/provider/edit",
    name: "Edit Provider",
    icon: "nc-icon nc-bank",
    component: <ComingSoon />,
    layout: "/admin",
    showInSidebar: false
  },
  {
    path: "/provider/details",
    name: "Provider Details",
    icon: "nc-icon nc-bank",
    component: <ProviderDetails />,
    layout: "/admin",
    showInSidebar: false
  },
  {
    path: "/provider/details/service",
    name: "Provider Service Details",
    icon: "nc-icon nc-bank",
    component: <ProviderServiceDetails />,
    layout: "/admin",
    showInSidebar: false
  },
  {
    path: "/provider/details/update-service-details",
    name: "Update Provider Service Details",
    icon: "nc-icon nc-bank",
    component: <UpdateProviderServiceDetails />,
    layout: "/admin",
    showInSidebar: false
  },
  {
    path: "/customer/details",
    name: "Customer Details",
    icon: "nc-icon nc-bank",
    component: <CustomerDetails />,
    layout: "/admin",
    showInSidebar: false
  },
  {
    name: "User Management",
    icon: <FaUser />,
    iconDown: "nc-icon nc-minimal-down",
    layout: "/admin",
    showInSidebar: true,
    subNav: [
      {
        path: "/customer/list",
        title: "Customer List",
        icon: <FaRegCircle />,
        component: <CustomerList />,
        layout: "/admin",
        name: "sub-nav",
        showInSidebar: true
      },
      {
        path: "/provider/list",
        title: "Provider List",
        icon: <FaRegCircle />,
        component: <ProviderList />,
        layout: "/admin",
        name: "sub-nav",
        showInSidebar: true
      },
      {
        path: "/admin/list",
        title: "Admin List",
        icon: <FaRegCircle />,
        component: <ProviderList />,
        layout: "/admin",
        name: "sub-nav",
        showInSidebar: true
      },
      {
        path: "/driver/list",
        title: "Driver List",
        icon: <FaRegCircle />,
        component: <ProviderList />,
        layout: "/admin",
        name: "sub-nav",
        showInSidebar: true
      }

    ],
  }
];


export default UserRoutes;